<template>
  <div v-if="active">
    <slot />
  </div>
</template>


<script>
export default {
  name: 'TabPillContent',
  props: {
    tabid: String,
    currentTab: String
  },
  computed: {
    active() {
      return this.tabid == this.currentTab
    }
  }
}
</script>